module.exports = __webpack_public_path__ + "img/ttl02.08aa39de.png";